module.exports = __webpack_public_path__ + "img/ring_g_o_null_1@3x.da13f374.png";